import { connect } from 'react-redux';
import Accounts from 'account/components/payout/accounts';
import { fetchAccountsIfNeeded, addPayoneerRequest } from 'common/ducks/payout';
import { setBannerError } from 'error';

const mapStateToProps = ({ user, payout }) => {
  return {
    user: user.profile_data,
    accounts: payout.accounts
  };
}

export default connect(mapStateToProps, {
  fetch: fetchAccountsIfNeeded,
  addPayoneerRequest,
  setBannerError
})(Accounts);



// WEBPACK FOOTER //
// ./account/containers/payout/accounts.js